import { TemplateKeyAndCategory } from "../../../models/templates";

interface TemplateUsedInProps {
  templateUsedIn: TemplateKeyAndCategory[];
}

function TemplateUsedIn({ templateUsedIn }: TemplateUsedInProps) {
  // Separate automations from other templates
  const automations = templateUsedIn.filter((t) => t.category === "automations");
  const otherTemplates = templateUsedIn.filter((t) => t.category !== "automations");

  // Sort both lists
  const sortedAutomations = [...automations].sort((a, b) => {
    const aKey = `${a.namespace}.${a.name}`;
    const bKey = `${b.namespace}.${b.name}`;
    return aKey.localeCompare(bKey);
  });

  const sortedOtherTemplates = [...otherTemplates].sort((a, b) => {
    const aKey = `${a.namespace}.${a.category}.${a.name}`;
    const bKey = `${b.namespace}.${b.category}.${b.name}`;
    return aKey.localeCompare(bKey);
  });

  return (
    <div className="p-3">
      {/* Automations Section */}
      {sortedAutomations.length > 0 && (
        <div className="mb-4">
          <h6>
            Used in {sortedAutomations.length} Automation{sortedAutomations.length !== 1 ? "s" : ""}:
          </h6>
          <ul>
            {sortedAutomations.map((template, index) => (
              <li key={index}>
                <a
                  href={`/templates/${template.namespace}/${template.category}/${template.name}/live`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {template.namespace}.{template.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Other Templates Section */}
      {sortedOtherTemplates.length > 0 && (
        <div>
          <h6>
            Used in {sortedOtherTemplates.length} Other Template{sortedOtherTemplates.length !== 1 ? "s" : ""}:
          </h6>
          <ul>
            {sortedOtherTemplates.map((template, index) => (
              <li key={index}>
                <a
                  href={`/templates/${template.namespace}/${template.category}/${template.name}/live`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {template.namespace}.{template.category}.{template.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* No usage message */}
      {sortedAutomations.length === 0 && sortedOtherTemplates.length === 0 && (
        <p>This template is not currently used anywhere.</p>
      )}
    </div>
  );
}

export default TemplateUsedIn;
